__turbopack_context__.v({
  "arrow": "CardList-module__EucmmW__arrow",
  "badge": "CardList-module__EucmmW__badge",
  "badgePrimary": "CardList-module__EucmmW__badgePrimary",
  "badgeSuccess": "CardList-module__EucmmW__badgeSuccess",
  "badgeWarning": "CardList-module__EucmmW__badgeWarning",
  "card": "CardList-module__EucmmW__card",
  "cardBody": "CardList-module__EucmmW__cardBody",
  "cardHeader": "CardList-module__EucmmW__cardHeader",
  "cardLabel": "CardList-module__EucmmW__cardLabel",
  "cardList": "CardList-module__EucmmW__cardList",
  "cardListVertical": "CardList-module__EucmmW__cardListVertical",
  "cardRow": "CardList-module__EucmmW__cardRow",
  "cardTime": "CardList-module__EucmmW__cardTime",
  "cardTitle": "CardList-module__EucmmW__cardTitle",
  "cardValue": "CardList-module__EucmmW__cardValue",
  "container": "CardList-module__EucmmW__container",
  "containerNoBg": "CardList-module__EucmmW__containerNoBg",
  "empty": "CardList-module__EucmmW__empty",
  "fadeIn": "CardList-module__EucmmW__fadeIn",
  "hash": "CardList-module__EucmmW__hash",
  "header": "CardList-module__EucmmW__header",
  "shimmer": "CardList-module__EucmmW__shimmer",
  "skeleton": "CardList-module__EucmmW__skeleton",
  "sourceLink": "CardList-module__EucmmW__sourceLink",
  "title": "CardList-module__EucmmW__title",
  "viewAll": "CardList-module__EucmmW__viewAll",
});
